import { ProductFilterQuery } from 'models/product';
import { MAX_INPUT_PRICE } from './transaction';

export const DEFAULT_PRODUCT_FILTER: ProductFilterQuery = {
  prices: [0, MAX_INPUT_PRICE],
  productGroupIds: [],
  supplierIds: [],
};
